<template>
  <ui-modal notification :close="close">
    <div class="modal-header">
      <h5 class="modal-title">
        Избранное<template v-if="items.length"> · {{ items.length }}</template>
      </h5>
      <button class="btn-close" type="button" @click="close"></button>
    </div>
    <div class="modal-body st">
      <div v-if="!items.length" class="st-empty">
        В избранном пока ничего нет. Отмечайте технику сердечком на карточке.
      </div>

      <template v-else>
        <div style="overflow-x: auto">
          <table class="st-table">
            <thead>
              <tr>
                <th style="width: 110px"></th>
                <th>Предмет лизинга</th>
                <th class="num">Стоимость</th>
                <th class="num">Примерный платёж</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td>
                  <img
                    v-if="item.image"
                    class="st-fav-photo"
                    :src="item.image"
                    alt=""
                    loading="lazy"
                  />
                  <div v-else class="st-fav-photo"></div>
                </td>
                <td>
                  <div class="st-product__title">{{ item.name }}</div>
                  <div class="st-note">
                    {{
                      item.type === "Новая техника"
                        ? "Новая техника"
                        : "С пробегом"
                    }}<template v-if="specs(item)">
                      · {{ specs(item) }}</template
                    >
                  </div>
                </td>
                <td class="num">{{ priceMask(item.price) }}</td>
                <td class="num">
                  <template v-if="payments[item.id]?.loading">
                    <ui-loading-span />
                  </template>
                  <template v-else-if="payments[item.id]?.secondElement">
                    <b>{{ rub(payments[item.id].secondElement) }}</b>
                    <div class="st-note">
                      аванс {{ payments[item.id].Deposit }}% ·
                      {{ payments[item.id].LeasingTerm }} мес.
                    </div>
                  </template>
                  <span v-else class="st-muted">—</span>
                </td>
                <td>
                  <div class="st-fav-actions">
                    <ui-button
                      class="st-btn st-btn--base"
                      :loading="applyingId === item.id"
                      :disabled="!!applyingId"
                      @click="apply(item)"
                      >Оформить онлайн</ui-button
                    >
                    <button
                      class="st-icon-btn"
                      type="button"
                      :disabled="isFavoritePending(item.id)"
                      :aria-label="'Удалить из избранного: ' + item.name"
                      title="Удалить из избранного"
                      @click="remove(item)"
                    >
                      <TrashIcon />
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="error" class="login-alert p-3 text-center mt-3">
          <div class="text-primary">Внимание!</div>
          <span>{{ error }}</span>
        </div>

        <p class="st-note mt-3 mb-0">
          Примерный платёж — быстрый расчёт на базовых условиях (аванс и срок
          указаны под суммой). Точные условия — в заявке.
        </p>
      </template>
    </div>
  </ui-modal>

  <!-- позиция без типа предмета лизинга: заявка менеджеру с её данными,
       поверх «Избранного» (после закрытия — снова список) -->
  <ApplicationModal
    v-if="itemRequest"
    kind="own"
    :initial="itemRequest"
    @close="itemRequest = null"
  />
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { quickCalc } from "@/views/catalog/api";
import TrashIcon from "@/assets/svg/trash.vue";
import ApplicationModal from "@/component/application/ApplicationModal.vue";
import { fromCatalogItem } from "@/component/application/fromCatalogItem";
import { applyCatalogItem, rub, priceMask, itemSpecs } from "../helpers";
// окно открывается из шапки на любой странице ЛК — стили дизайн-системы подключаем здесь
import "../home.css";

export default {
  name: "FavoritesModal",
  components: { TrashIcon, ApplicationModal },
  data() {
    return {
      // позиция, по которой сейчас оформляется заявка
      applyingId: null,
      // окно заявки по позиции без типа ПЛ (предзаполненные поля формы)
      itemRequest: null,
      // примерный платёж по id позиции: { loading } либо ответ quickCalc
      payments: {},
      error: null,
    };
  },
  computed: {
    ...mapGetters({
      items: "favorites/getFavorites",
      isFavoritePending: "favorites/isFavoritePending",
    }),
  },
  created() {
    this.items.forEach(this.calcPayment);
  },
  methods: {
    ...mapActions({ toggleFavorite: "favorites/toggleFavorite" }),
    ...mapMutations({ setOpen: "favorites/setFavoritesOpen" }),
    rub,
    priceMask,
    specs: itemSpecs,
    close() {
      this.setOpen(false);
    },
    // быстрый расчёт по позиции на базовых условиях (аванс и срок не передаются —
    // сервер берёт значения по умолчанию и возвращает их в ответе)
    async calcPayment(item) {
      if (!item.price) return;
      this.payments = { ...this.payments, [item.id]: { loading: true } };
      let response;
      try {
        response = await quickCalc({ LeasingSubjectPriceBase: item.price });
      } catch (e) {
        response = null;
      }
      this.payments = {
        ...this.payments,
        [item.id]: response && response.status ? response : {},
      };
    },
    // «Оформить онлайн» — тот же поток, что на карточке: расчёт и лизинг,
    // затем переход на заявку; окно закрывается при переходе
    async apply(item) {
      // без типа предмета лизинга онлайн-расчёт не построить — заявка менеджеру
      if (!item.leasing_subject_type) {
        this.itemRequest = fromCatalogItem(item);
        return;
      }
      if (this.applyingId) return;
      this.applyingId = item.id;
      this.error = null;
      const error = await applyCatalogItem(item, this.$router);
      this.applyingId = null;
      if (error) {
        this.error = error;
      } else {
        this.close();
      }
    },
    async remove(item) {
      this.error = await this.toggleFavorite(item.id);
    },
  },
};
</script>
